import React from "react";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";

import EditIcon from "@mui/icons-material/Edit";
import BlockIcon from "@mui/icons-material/Block";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

export default function DialogClienteAcordoMaterialAlternativosLista({
  open,
  onClose,
  PaperComponent,
  acordo,
  alternativos,
  formatarValor,
  modoEdicao = false,
  abrirNovoAlternativo,
  editarAlternativo,
  inativarAlternativo,
}) {
  const valorFormatado =
    acordo?.tipodesconto === "PERCENTAGEM"
      ? `${formatarValor(acordo?.valor)}%`
      : `${formatarValor(acordo?.valor)} €`;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth PaperComponent={PaperComponent}>
      <DialogTitle className="draggable-dialog-title" style={{ cursor: "move" }}>
        Resumo do acordo
      </DialogTitle>

      <DialogContent>
        <MDBox display="grid" gap={2} mt={1}>
          <MDBox display="grid" gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }} gap={1.5}>
            <MDBox>
              <MDTypography variant="caption" color="text" display="block" fontWeight="bold">
                Cliente
              </MDTypography>
              <MDTypography variant="caption" color="dark">
                {acordo?.cliente || "-"}
              </MDTypography>
              <MDTypography variant="caption" color="dark" display="block">
                {acordo?.refcliente || ""}
              </MDTypography>
            </MDBox>

            <MDBox>
              <MDTypography variant="caption" color="text" display="block" fontWeight="bold">
                Fabricante
              </MDTypography>
              <MDTypography variant="caption" color="dark">
                {acordo?.fabricante || "-"}
              </MDTypography>
              <MDTypography variant="caption" color="dark" display="block">
                {acordo?.reffabricante || ""}
              </MDTypography>
            </MDBox>
          </MDBox>

          <MDBox
            display="grid"
            gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr 1fr 1fr" }}
            gap={1.5}
          >
            <MDBox>
              <MDTypography variant="caption" color="text" display="block" fontWeight="bold">
                Tipo
              </MDTypography>
              <MDTypography variant="caption" color="dark">
                {acordo?.tipodesconto || "-"}
              </MDTypography>
            </MDBox>

            <MDBox>
              <MDTypography variant="caption" color="text" display="block" fontWeight="bold">
                Valor
              </MDTypography>
              <MDTypography variant="caption" color="dark">
                {valorFormatado}
              </MDTypography>
            </MDBox>

            <MDBox>
              <MDTypography variant="caption" color="text" display="block" fontWeight="bold">
                Suporte JF
              </MDTypography>
              <MDTypography variant="caption" color="dark">
                {formatarValor(acordo?.suporte_jf_perc)}%
              </MDTypography>
            </MDBox>

            <MDBox>
              <MDTypography variant="caption" color="text" display="block" fontWeight="bold">
                Suporte fabricante
              </MDTypography>
              <MDTypography variant="caption" color="dark">
                {formatarValor(acordo?.suporte_fabricante_perc)}%
              </MDTypography>
            </MDBox>
          </MDBox>

          <MDBox
            display="grid"
            gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr 1fr 1fr" }}
            gap={1.5}
          >
            <MDBox>
              <MDTypography variant="caption" color="text" display="block" fontWeight="bold">
                Data inicial
              </MDTypography>
              <MDTypography variant="caption" color="dark">
                {acordo?.datainicial ? String(acordo.datainicial).substring(0, 10) : "-"}
              </MDTypography>
            </MDBox>

            <MDBox>
              <MDTypography variant="caption" color="text" display="block" fontWeight="bold">
                Data final
              </MDTypography>
              <MDTypography variant="caption" color="dark">
                {acordo?.datafinal ? String(acordo.datafinal).substring(0, 10) : "-"}
              </MDTypography>
            </MDBox>

            <MDBox>
              <MDTypography variant="caption" color="text" display="block" fontWeight="bold">
                Utilização única
              </MDTypography>
              <MDTypography variant="caption" color="dark">
                {Number(acordo?.utilizacao_unica || 0) === 1 ? "Sim" : "Não"}
              </MDTypography>
            </MDBox>

            <MDBox>
              <MDTypography variant="caption" color="text" display="block" fontWeight="bold">
                Estado
              </MDTypography>
              <MDTypography variant="caption" color="dark">
                {Number(acordo?.inativo || 0) === 1 ? "Inativo" : "Ativo"}
              </MDTypography>
            </MDBox>
          </MDBox>

          {acordo?.obs && (
            <MDBox>
              <MDTypography variant="caption" color="text" display="block" fontWeight="bold">
                Observações
              </MDTypography>
              <MDTypography variant="caption" color="dark">
                {acordo.obs}
              </MDTypography>
            </MDBox>
          )}

          <MDBox mt={1}>
            <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={1}>
              <MDTypography variant="h6">Materiais</MDTypography>

              {modoEdicao && (
                <MDButton color="success" size="small" onClick={abrirNovoAlternativo}>
                  Inserir material
                </MDButton>
              )}
            </MDBox>

            <MDBox sx={{ borderTop: "1px solid #eee", maxWidth: "100%", overflowX: "auto" }}>
              {alternativos.length === 0 && (
                <MDBox
                  py={1}
                  px={1}
                  sx={{
                    backgroundColor: "#f8f9fa",
                    borderTop: "1px solid #eee",
                  }}
                >
                  <MDTypography variant="caption" color="text" display="block" fontWeight="bold">
                    Sem materiais.
                  </MDTypography>
                </MDBox>
              )}

              {alternativos.map((mat) => {
                const inativo = Number(mat.inativo || 0) === 1;

                return (
                  <MDBox
                    key={mat.id}
                    display="grid"
                    gridTemplateColumns={{
                      xs: "1fr",
                      md: modoEdicao ? "140px 1fr 90px" : "140px 1fr",
                    }}
                    gap={1}
                    alignItems="center"
                    py={0.8}
                    px={1}
                    sx={{
                      minWidth: { xs: "100%", md: 850 },
                      backgroundColor: inativo ? "#f1f3f5" : "#f8f9fa",
                      borderTop: "1px solid #eee",
                      opacity: inativo ? 0.65 : 1,
                    }}
                  >
                    <MDTypography variant="caption" color="text" display="block" fontWeight="bold">
                      {mat.refmaterial}
                    </MDTypography>

                    <MDTypography variant="caption" color="text" display="block" fontWeight="bold">
                      {mat.material}
                    </MDTypography>

                    {modoEdicao && (
                      <MDBox display="flex" justifyContent="flex-end" gap={0.5}>
                        <IconButton
                          size="small"
                          color="primary"
                          onClick={() => editarAlternativo(mat)}
                          title="Editar"
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>

                        <IconButton
                          size="small"
                          color={inativo ? "inherit" : "error"}
                          onClick={() => inativarAlternativo(mat)}
                          title={inativo ? "Reativar material" : "Cancelar material"}
                        >
                          <BlockIcon fontSize="small" />
                        </IconButton>
                      </MDBox>
                    )}
                  </MDBox>
                );
              })}
            </MDBox>
          </MDBox>
        </MDBox>
      </DialogContent>

      <DialogActions sx={{ flexWrap: "wrap", gap: 1 }}>
        <MDButton color="secondary" onClick={onClose}>
          Fechar
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
